import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_CASE_ID } from 'routes/cases/-searchParams'
import { Route as NewRoute } from 'routes/cases/edit'

export const Route = createFileRoute(
  '/cases/(deprecated_routes)/$siteID/edit/$caseID'
)({
  beforeLoad: ({ params }) => {
    const { siteID, caseID } = params
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: siteID,
        [SEARCH_PARAM_CASE_ID]: caseID,
      }),
      replace: true,
    })
  },
})
